<template>
  <van-col span="24">
    <!-- ✅ Блок 1: Скелетон-лоадер -->
    <div v-if="isLoading" class="skeleton-history-wrapper">
      <div class="skeleton-history-item" v-for="n in 10" :key="n">
        <div class="skeleton-line title"></div>
        <div class="skeleton-line short"></div>
        <div class="skeleton-line short"></div>
      </div>
    </div>

    <!-- Блок с данными -->
    <template v-else-if="history && history.length">
      <div v-for="(item, index) in history" :key="index" class="history-item">
        <van-row>
          <h5 class="energy-title">
            {{ $t("paymentHistory.title") }}
          </h5>
          <van-col span="12" class="history-left">
            {{ $t("paymentHistory.period") }}
          </van-col>
          <van-col span="12" class="history-right">
            {{ item.date }}
          </van-col>
          <van-col span="12" class="history-left">
            {{ $t("paymentHistory.amount") }}
          </van-col>
          <van-col span="12" class="history-right">
            {{ item.amount }} грн
          </van-col>
        </van-row>
      </div>
    </template>

    <!-- Блок "Нет данных" -->
    <template v-else>
      <div class="place-content-center no-data">
        <info-message>
          {{ $t("global.noData") }}
        </info-message>
      </div>
    </template>
  </van-col>
</template>

<script>
import InfoMessage from "@/components/content/InfoMessage";
import { mapState } from "vuex";

export default {
  name: "PaymentHistoryList",
  components: { InfoMessage },
  computed: {
    ...mapState({
      history: (state) => state.PaymentHistory.paymentHistory,
      // ✅ Получаем статус загрузки
      isLoading: (state) => state.PaymentHistory.isLoading,
      account: (state) => state.Auth.account,
    }),
  },
  watch: {
    // Отслеживаем изменение счета
    account: {
      handler(newAccount, oldAccount) {
        // Если изменился номер счета или это первая загрузка
        if (newAccount && (!oldAccount || newAccount.ls !== oldAccount.ls)) {
          console.log("Загрузка истории платежей для счета:", newAccount.ls);
          // Передаем accountId для загрузки истории конкретного счета
          this.$store.dispatch("PaymentHistory/getAllPaymentHistory", {
            accountId: newAccount.ls,
          });
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped>
/* Стили точно такие же, как и для истории показаний */
.history-item {
  background-color: #0e121c;
  border-radius: 8px;
  padding: 16px;
  margin: 0 15px 15px;
  color: #ecf0f1;
}
.energy-title {
  color: #3498db;
  font-size: 18px;
  font-weight: bold;
  margin: 0 0 12px 0;
  width: 100%;
}
.history-left,
.history-right {
  font-size: 16px;
  line-height: 1.6;
}
.history-left {
  color: #ffffff;
}
.history-right {
  text-align: right;
  font-weight: 500;
  color: #ffffff;
}
.no-data {
  margin-top: 20px;
}
.loading-block {
  margin-top: 30vh;
  text-align: center;
}
.loading-text {
  color: #bdc3c7;
  margin-top: 15px;
  font-size: 16px;
}

/* Стили для скелетона */
.skeleton-history-wrapper {
  padding: 0 15px;
}
.skeleton-history-item {
  background: #0e121c;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 15px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.skeleton-line {
  height: 16px;
  border-radius: 4px;
  background: linear-gradient(90deg, #222 25%, #333 50%, #222 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}
.skeleton-line.title {
  width: 40%;
  height: 20px;
}
.skeleton-line.short {
  width: 60%;
}
@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
</style>
